import type { MyProfileUserDetails } from "../types";
import { ddMmYyyyToYmd } from "utils/dateTime";

const ID_PROOF_DOCUMENT_PATH = /^(\d+)\/proof\/(\d{2}-\d{2}-\d{4})\/([^/]+)\/(.+)$/;

export interface ParsedIdProofDocumentPath {
  userId: number;
  uploadDateDdMmYyyy: string;
  storageToken: string;
  fileName: string;
  uploadedOnIsoDate: string;
}

export function parseIdProofDocumentPath(
  documentPath: string | null | undefined
): ParsedIdProofDocumentPath | null {
  if (!documentPath?.trim()) return null;
  const m = documentPath.trim().match(ID_PROOF_DOCUMENT_PATH);
  if (!m) return null;
  const [, userId, uploadDateDdMmYyyy, storageToken, fileName] = m;
  if (!userId || !uploadDateDdMmYyyy || !storageToken || !fileName) return null;
  const uploadedOnIsoDate = ddMmYyyyToYmd(uploadDateDdMmYyyy);
  if (!uploadedOnIsoDate) return null;

  return {
    userId: Number(userId),
    uploadDateDdMmYyyy,
    storageToken,
    fileName,
    uploadedOnIsoDate,
  };
}

export function displayNameFromMyProfileUserDetails(
  user: MyProfileUserDetails | null | undefined
): string {
  if (!user) return "";
  const name = [user.first_name, user.middle_name, user.surname]
    .map((p) => (p ?? "").trim())
    .filter(Boolean)
    .join(" ")
    .trim();
  if (name) return name;
  return (user.email ?? user.username ?? "").trim();
}
